/**
 * View component for /my-agenda/expired
 *
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import actions
import * as contentModuleActions from '../../contentModule/contentModuleActions';

// import global components
import Base from '../../../global/components/BaseComponent.js.jsx';
import StudyLayout from '../../study/components/StudyLayout.js.jsx';

// import components 
import AgendaTmCard from '../components/AgendaTmCard.js.jsx';

// not updating links here because this should no longer be used with london handling agenda

class ExpiredAgenda extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch } = this.props;

    // old page - redirect to london certs view just in case
    window.location.replace(`${window.agendaUrl}/certificates`);
    
    dispatch(contentModuleActions.fetchListIfNeeded('agenda-status', 'expired'));
  }

  render() {
    const { contentModuleStore } = this.props;

    const expiredList = contentModuleStore.lists['agenda-status'] ? contentModuleStore.lists['agenda-status']['expired'] : {};
    // const expiredItems = contentModuleStore.util.getList('agenda-status', 'expired');
    
    const expiredItems = expiredList ? expiredList.agendaItems : [];
    // console.log(expiredItems)
    
    const isEmpty = (
      !expiredItems
      || expiredItems.length === 0
    )

    const isFetching = (
      !expiredList
      || expiredList.isFetching
    )
    return(
      <StudyLayout>
        <Helmet
          title={"Expired Training | Pro-ficiency"}
        />
        <div className="flex">
          <section className="section my-agenda -program">
            {/* <div className="-content-wrapper"> */}
            <div className="yt-container">
              <div className="-header">
                <h2>Expired training</h2>
              </div>
              <hr/>
              { isEmpty ?
                (isFetching ?
                  <div className="u-centerText">
                    <div className="loading"></div>
                  </div>
                :
                  <div className="u-centerText">
                    <h2>No expired training found!</h2>
                    <p>Please <Link to="/contact-us">contact</Link> your administrator if you feel this was an error.</p>
                    <p>Or navigate back to your <Link to="/my-agenda">Agenda</Link></p>
                  </div>
                )
                :
                <div style={{ opacity: isFetching ? 0.5 : 1 }}>
                  <div className="yt-row">
                    {expiredItems.map((agendaItem, i) => 
                      <AgendaTmCard
                        agendaItem={agendaItem}
                        key={'optInc_' + agendaItem._contentModule + '_' +i }
                        contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                      /> 
                    )}
                  </div>
                </div>
              }
            </div>
          </section>
        </div>
      </StudyLayout>
    )
  }
}


ExpiredAgenda.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    contentModuleStore: store.contentModule
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(ExpiredAgenda)
);



// WEBPACK FOOTER //
// modules/agenda/views/ExpiredAgenda.js.jsx